import { useMedia } from 'react-use';
import { twMerge } from 'tailwind-merge';

import { tagStyles, tagsContainerStyles } from 'components/Cards/styles/ResourceCard.styles';

import screens from 'theme/spacing/screens';

import type { ResourceCardProps } from 'components/Cards/ResourceCard';
import type { FC } from 'react';

import 'components/Cards/styles/ResourceCardTags.css';

interface ResourceCardTagsProps {
  tags: ResourceCardProps['tags'];
  tagPosition: 'relative' | 'absolute';
  tagBackgroundColor: ResourceCardProps['tagBackgroundColor'];
  tagTextColor: ResourceCardProps['tagTextColor'];
}
const ResourceCardTags: FC<ResourceCardTagsProps> = ({ tagPosition, tagBackgroundColor, tagTextColor, tags }) => {
  const isMobile = useMedia(`(max-width: ${screens.sm})`, false);
  if (!tags || tags.length === 0) {
    return null;
  }

  const allTags = [...tags, ...tags];
  const animationDuration = `${allTags.length * 2}s`;

  return (
    <div className={twMerge(tagsContainerStyles({ position: tagPosition, backgroundColor: tagBackgroundColor }))}>
      <div
        className="tags-container"
        style={{
          animationDuration,
          width: 'max-content',
        }}
      >
        {allTags.map((cat, index) => {
          if (!cat) {
            return null;
          }

          return (
            <p
              key={`${cat.id}-${index}`}
              className={`${twMerge(tagStyles({ textColor: tagTextColor }))} ${isMobile && 'mr-4'}`}
              style={{ width: 'fit-content', padding: '0 12px' }}
            >
              {cat.name}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default ResourceCardTags;
